import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getOperatorReportFormStacks = async ({ startDate, endDate }: { startDate: string; endDate: string }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      startDate,
      endDate,
    },
    query: graphql(`
      query OperatorReportFormStacks($startDate: String!, $endDate: String!) {
        operatorReportFormStacks(startDate: $startDate, endDate: $endDate) {
          id
          operatorName
          type
          date
        }
      }
    `),
  });

  return response.data.operatorReportFormStacks;
};
